import { configureStore } from '@reduxjs/toolkit';
import { referrerPageReducer, referralsReducer, userReducer } from 'shared/slices';

import type { IApplicationContext } from 'shared/types/applicationContext';
import { IPreloadedState } from '../../types/referrer/store';

/**
 * Хелпер для создания Redux стора
 * @param context IApplicationContext - контекст приложения
 * @param preloadedState IPreloadedState - предзагруженное состояние
 * @param debugEnabled boolean - флаг доступности Redux Devtools на деве
 */
export function createReferrerReduxStore(
  context: IApplicationContext,
  preloadedState: IPreloadedState,
  debugEnabled: boolean,
) {
  const projectName = context.config.getStrict<string>('projectName');

  return configureStore({
    devTools: debugEnabled ? { name: projectName } : false,
    middleware: getDefaultMiddleware =>
      getDefaultMiddleware({
        thunk: {
          extraArgument: context,
        },
      }),
    preloadedState,
    reducer: {
      page: referrerPageReducer,
      user: userReducer,
      referral: referralsReducer,
    },
  });
}
